/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import { Form, Modal, Toast } from "antd-mobile";
import { ExclamationCircleFill } from "antd-mobile-icons";
import { useNavigate } from "react-router-dom"
import { base1 } from "api/config";
import { getSocialSubsidy, getSocialSubsidyTime, getDict, getCalculateResult, getConfirmCondition, submitWithFormData } from "api/api";
import { UserContext } from "utils/getContext";
import { getAreaObj, getUserObj } from "utils/getData";
import { judgeSex,idCardHide, infoCardType } from "utils/ruleType";
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";
import { socialSecurityPage1 } from "data/socialSecurityForm";
import '../../../static/css/tip.css'
/** 社会保险补贴 */
export function SubsidyDev() {
  const myContext = useContext(UserContext);
  const { userInfo } = myContext;
  const { name, idNum, sex, birthday, USER_MOBILE } = userInfo ? userInfo : {};
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({});
  const [stepNum, setStepNum] = useState(1);
  const [formId, setFormId] = useState("");
  const [personTypeArr, setPersonTypeArr] = useState()
  // const [newPostData, setNewPostData] = useState({})
  // const [btnVisible, setBtnVisible] = useState(true); //勾选个人承诺状态
  const [flag, setFlag] = useState(true); //勾选接口返回状态
  // const [resultInfo, setResultInfo] = useState()//测算结果信息
  const title = ["申报信息", "提交申请"];
  const msgTitle = '社会保险补贴申请'
  const pageData = [socialSecurityPage1];
  const navigate = useNavigate()

  const { startDate, endDate, applyYear } = postData;

  /** 对默认返回的参数进行处理后显示到页面上 */
  useEffect(() => {
    if (userInfo) {
      form.setFieldsValue({
        username: idCardHide(name, 1, name.length - 1) || '',
        gender: judgeSex(sex),
        age: new Date().getFullYear() - new Date(birthday).getFullYear() || null,
        FPHONE: USER_MOBILE || '',
      });
      // setNewPostData({ ...postData, name, idNum })
    }
    // 检查会话中是否有数据
    const SubsidyFormInfo = sessionStorage.getItem("SubsidyFormInfo");
    if (SubsidyFormInfo) {
      const formInfo = JSON.parse(SubsidyFormInfo);
      // 从会话中获取到的数据，需要重新赋值给表单，并需要处理日期格式
      formInfo.applyYear = new Date(formInfo.applyYear)
      form.setFieldsValue(formInfo);
      // 给一个标识，标识数据是从会话中获取的
      sessionStorage.setItem("SubsidyFormInfoFlag", true);
      // 从会话中获取到的数据，需要重新赋值给postData
      // 循环fromInfo，将key和value调用setFormInfo
      let newData = {}
      for (const key in formInfo) {
        // setFormInfo(key, formInfo[key])
        // 如果formInfo[key]是数组，需要转换成字符串
        if (Array.isArray(formInfo[key])) {
          newData[key] = formInfo[key].join(',')
        } else if (key === 'applyYear') {
          newData[key] = dayjs(formInfo[key]).format('YYYY')
        } else {
          newData[key] = formInfo[key]
        }
      }
      setPostData(newData)
      setFlag(false)
    }
  }, [sex, birthday, name, form, userInfo, idNum]);

  /**获取补贴对象类型 5.2 第一步调用 */
  useEffect(() => {
    if (applyYear && startDate) {
      // startDate之有月份，需要加上年份格式是202201
      const temp = {
        idNum,
        startDate: `${applyYear}${startDate}`,
      }
      //判断postData里有StartData,才调接口
      getSocialSubsidy(temp).then((res) => {
        if (res.success && res.data.status === 1) {
          //将后端返回的type类型转为字符串
          const type = String(res.data.type)
          // 通过ID和type的比对职工类型，把name塞进去
          form.setFieldsValue({
            personType: personTypeArr?.find(t => t.id === type).name
          });
        } else if (res.success && res.data.status === 0) {
          Toast.show({
            icon: "fail",
            content: `${res.data.result}` || '查询失败',
          });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNum, startDate, applyYear, personTypeArr]);

  /**申请时间 */
  useEffect(() => {
    //当用户选择申报年份,起始月份,结束月份后调用申请时间接口
    if (applyYear && startDate && endDate) {
      /** 对发出的参数数据【PostData】进行处理 */
      const temp = {
        idNum: idNum,
        applyYear: applyYear,
        startDate: `${applyYear}${startDate}`,
        endDate: `${applyYear}${endDate}`,
        name: name,
      }
      getSocialSubsidyTime(temp).then(res => {
        if (res.success && res.data.status === 0) {
          Toast.show({
            icon: "fail",
            content: `${res.data.result}` || "",
          })
          setFlag(true)
        } else {
          setFlag(false)
        }
      }).finally(() => {
        setTimeout(() => {
          getResultData(temp)
        }, 3000)
      })
    }
  }, [idNum, applyYear, startDate, endDate]);

  /** 测算结果查询*/
  const getResultData = async (temp) => {
    if (!flag) return
    const res = await getCalculateResult(temp)
    const { success, data } = res
    const { url } = data
    // 判断是否有url，有就跳转，没有就跳转到首页，并提示 页面正在建设中
    const onConfirm = () => {
      if (url) {
        navigate(`${data.url}`)
      } else {
        return true
      }
    }
    if (success && (data.status === 1)) {
      // setResultInfo(res.data.result)
      setFlag(false)
    } else if (success && (data.status === 0)) {
      setFlag(true)
      Modal.alert({
        header: (
          <ExclamationCircleFill
            style={{
              fontSize: 50,
              color: 'var(--adm-color-warning)',
            }}
          />
        ),
        title: '注意',
        content: (
          <div>
            {data.result}
          </div>
        ),
        confirmText: url ? '前往>>' : '确定',
        // confirmText: '前往>>',
        onConfirm
      })
    }
  }



  /** 获取表单ID */
  useEffect(() => {
    const date = dayjs().format("YYYYMMDDHHmmss");
    setFormId(date + guid());
    // 先获取到所有的职工类型，存起来
    getDict("T_DIC_EmpHard").then((res) => {
      setPersonTypeArr(res)
    });
  }, []);

  /** 获取表单ID */
  function guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        // eslint-disable-next-line no-bitwise
        const r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        // eslint-disable-next-line no-mixed-operators
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  /** 更新提交表单接口参数数据 */
  function setFormInfo(name, value) {
    const newPostData = { ...postData };
    // 如果applyYear还未填写就提示
    if (!applyYear && name !== "applyYear") {
      Toast.show({
        icon: "fail",
        content: "请选择申报年份",
      });
      setFlag(true)
    } else {
      setFlag(false)
    }
    // 如果结束月份小于开始月份就提示
    if (name === "endDate" && value < startDate) {
      Toast.show({
        icon: "fail",
        content: "结束月份不能小于开始月份",
      });
      return
    }
    // 如果开始月份大于结束月份就提示
    if (name === "startDate" && value > endDate) {
      Toast.show({
        icon: "fail",
        content: "开始月份不能大于结束月份",
      });
      return
    }
    newPostData[name] = value;
    setPostData(newPostData);
  }
  //提交表单
  async function handleSubmitFormClick(setLoading) {
    if (stepNum === title.length - 1) {

      if (flag) {
        return
      }
      setLoading(true);
      const formData = await form.validateFields();
      //表单提交方式
      const postData2 = new FormData();
      // 判断applyYear是字符串还是日期，如果是日期就转成字符串
      let applyYear = ''
      if (typeof formData.applyYear === "object") {
        applyYear = dayjs(formData.applyYear).format("YYYY");
      } else {
        applyYear = formData.applyYear
      }

      for (const key in formData) {
        if (key) {
          // 如果是开始月份和结束月份，需要和applyYear拼接成一个完整的日期
          if (key === "startDate" || key === "endDate") {
            postData2.append(key, `${applyYear}${formData[key]}`);
          } else {
            postData2.append(key, formData[key]);
          }
        }
      }
      // 拼装成新的参数
      const params = {
        idNum: idNum,
        applyYear,
        name: name
      }
      //校验
      const { data, success } = await getConfirmCondition(params);
      const submitStartDate = `${applyYear}${postData.startDate}`;
      const submitEndDate = `${applyYear}${postData.endDate}`;
      const personType = personTypeArr.find(item => item.name === formData.personType)
      const submitParams = {
        name,
        idNum,
        sex,
        age: formData.age,
        applyYear,
        bankNum: formData.FBANKNUM,
        type: '67',
        mobile: formData.FPHONE || USER_MOBILE,
        startMonth: submitStartDate,
        endMonth: submitEndDate,
        subsidyAimType: personType.id,
        cardType: infoCardType(userInfo.CARD_TYPE)  // 证件类型
      }
      if (success && data.status === '0') {
        Modal.alert({
          header: (
            <ExclamationCircleFill
              style={{
                fontSize: 50,
                color: 'var(--adm-color-warning)',
              }}
            />
          ),
          title: '注意',
          content: (
            <>
              {data.details?.map((item, index) => {
                return <div className="modal-item">
                  <span>({index + 1})&nbsp;&nbsp;{item.condition}</span>
                  <span className={`${item.result === '1' ? 'passItem' : 'failItem'}`}>
                    {item.result === '1' ? '已通过' : '未通过'}
                  </span>
                </div>
              })}
            </>
          ),
        })
      } else if (success && data.status === '1') {
        const res = await submitWithFormData(submitParams, `${base1}hrss/addSocialInsuranceInfo`)
        if (res?.code === 200) {
          // 将SubsidyFormInfo从缓存中删除
          sessionStorage.removeItem('SubsidyFormInfo');
          setStepNum(stepNum + 1)
        } else {
          Toast.show({
            icon: 'fail',
            content: '提交失败，请检查内容并重试',
          })
        }
      } else if (!success) {
        Toast.show({
          icon: 'fail',
          content: '提交失败，请检查内容并重试',
        })
      }
      setLoading(false);
    }
  }

  /**点击查看社保缴费情况 */
  async function handleCheckClick() {
    const formData = await form.validateFields();
    if (flag) {
      return
    }
    // 参数必须都有才能跳转
    if (idNum && name && startDate && endDate) {
      navigate(
        { pathname: '/contribution' },
        {
          state:
          {
            idNum: idNum,
            name: name,
            startDate: `${applyYear}${startDate}`,
            endDate: `${applyYear}${endDate}`,
          }
        })
      // 将表单信息存入本地会话中
      sessionStorage.setItem('SubsidyFormInfo', JSON.stringify(formData))
    } else {
      Toast.show({
        icon: "fail",
        content: '请先填写完整信息',
      });
    }
  }

  // 初始化表单渲染模板
  const getType = (arr, index) => (
    <GetFormType
      key={index}
      item={arr}
      form={form}
      setFormInfo={setFormInfo}
      getUserObj={getUserObj}
      // setBtnVisible={setBtnVisible}
      formId={formId}
      getAreaObj={getAreaObj}
      postInfo={postData}
      msgTitle={msgTitle}
    />
  );

  // 离开页面，清除缓存，去掉标识，防止下次进入页面时，验证码不验证
  useEffect(() => {
    return () => {
      sessionStorage.removeItem('SubsidyFormInfoFlag');
    }
  }, [])

  return (
    <FromSteps
      //resultInfo={resultInfo}
      stepNum={stepNum}
      title={title}
      getType={getType}
      setStepNum={setStepNum}
      form={form}
      pageData={pageData}
      //newPostData={newPostData}
      handleCheckClick={handleCheckClick}
      //btnVisible={btnVisible}
      flag={flag}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  );
}
